"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAssetMarginMode = exports.useAssetMarginMode = void 0;
const FutureAPI_1 = require("../../../apis/FutureAPI");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const Assets_1 = require("./../../../component/Assets");
const Trade_1 = require("./../../../component/Trade");
const errors_1 = require("./../../../interface/errors");
/**获取账户资产保证金模式 */
function useAssetMarginMode(accountType, active = true) {
    const { assets_margin_mode } = (0, Assets_1.useCustomAssets)(accountType, active);
    return [assets_margin_mode, exports.setAssetMarginMode];
}
exports.useAssetMarginMode = useAssetMarginMode;
const setAssetMarginMode = (mode, options) => {
    const { handleIsolatedModeSymbols = () => (0, rxjs_1.of)(true) } = options || {};
    function checkStatus() {
        return (0, Assets_1.getCustomAssetsObservable)().pipe((0, operators_1.take)(1), (0, operators_1.map)((assets) => {
            // 检测所有quoteRisk为非 trading 时，报错
            // if (
            //     assets.quoteRisks?.some((quoteRisk) => {
            //         return quoteRisk.risk_state !== TraderAccountRiskState.TRADING;
            //     })
            // ) {
            //     throw ASSET_MARGIN_MULTI_TO_SINGLE_HAS_DEBTS;
            // }
            if (Trade_1.CalculateUtils.isMultiAssetMarginMode(mode)) {
                // 单币种保证金切联合保证金校验
            }
            else {
                // 联合保证金切换单币种保证金时校验所有非模拟币quote资产是否有负债，若有负债，则报错提示
                const hasDebts = assets.balances.some((balance) => {
                    return !Trade_1.CalculateUtils.isVirtualSymbol(balance.coin) && new trade_utils_lib_1.SafeDecimal(balance.debts).lt(0);
                });
                if (hasDebts) {
                    throw errors_1.ASSET_MARGIN_MULTI_TO_SINGLE_HAS_DEBTS;
                }
            }
        }));
    }
    const checkIsolatedModeSymbols = () => (0, FutureAPI_1.queryIsolatedModeSymbols)().pipe((0, operators_1.mergeMap)((result) => {
        var _a;
        const symbols = (_a = result === null || result === void 0 ? void 0 : result.symbols) === null || _a === void 0 ? void 0 : _a.map(({ symbol }) => symbol);
        if ((symbols === null || symbols === void 0 ? void 0 : symbols.length) > 0) {
            return handleIsolatedModeSymbols(symbols);
        }
        return (0, rxjs_1.of)(true);
    }));
    return checkStatus().pipe((0, operators_1.mergeMap)(() => {
        if (Trade_1.CalculateUtils.isMultiAssetMarginMode(mode)) {
            return checkIsolatedModeSymbols();
        }
        return (0, rxjs_1.of)(true);
    }), (0, operators_1.mergeMap)((bool) => {
        if (bool) {
            return (0, FutureAPI_1.setAssetMarginModeApi)(mode).pipe((0, operators_1.map)(() => true));
        }
        return (0, rxjs_1.of)(bool);
    }), (0, operators_1.tap)((bool) => {
        if (bool) {
            (0, Assets_1.refreshAccountDetail)();
        }
    }), (0, operators_1.catchError)((error) => {
        return (0, rxjs_1.throwError)((0, trade_utils_lib_1.getTradeDependencyInstance)().localizeError(error));
    }));
};
exports.setAssetMarginMode = setAssetMarginMode;
